module.exports = __webpack_public_path__ + "static/media/structure.4c707b90.png";